import type { FaireProductEntity } from "../../entity_types/product";

export const p_2r5czfj5ua: FaireProductEntity = {
  token: "p_2r5czfj5ua",
  type: "product",
  name: "Mint Cacao Bliss - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/6b6fcf3dafb660c6430c46b999baa794b86a2c8f41bcfe3f7a0f9a0692a4fc27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/506481a6d5206e1216d17fa824e8efb54233872a717c8c0ce3f39f4093c639e1.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nA nourishing take on your evening sweet fix, this Mint Cacao Bliss tea sneaks in the beauty-boosting benefits of antioxidant powerhouse raw cacao. Soothing peppermint helps support digestion - your delicious secret weapon to taming post-meal bloat. \n\nIt’s like cozy, (healthy!) dessert in a cup. \n\n\n100% ORGANIC - SUPERFOODS - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \n\n\nWhen to Steep:\n\n * Instead of your morning coffee \n * As a 2pm sugar-free treat \n * After dinner with dessert \n\n\nTrace amounts of caffeine from cocoa\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:47.183Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
